import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, NgModule, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

declare const $: any;

@Component({
  selector: 'state',
  template: `<span *ngIf="caption" class="badge {{color}}">{{caption}}</span>`,
  encapsulation: ViewEncapsulation.None,
})

export class StateComponent {
  @Input() public name: string = '';
  public caption: string = '';
  @Input() public value: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public color: string;
  @Input() public options: any;
  @Input() public item: any;
  public init: boolean = false;

  constructor() {
  }

  initialize() {
    if (!this.options) {
      this.options = { assign: [], fieldName: '' };
    }
  }

  ngOnInit() {
    this.initialize();
    if (!this.init) {
      this.init = true;
      for (let i = 0; i <= this.options.assign.length - 1; i++) {
        if (this.value != null) {
          if (this.options.assign[i].value == this.value.trim()) {
            this.color = this.options.assign[i].color;
            break;
          }
        }
      }
      //if ((this.options.fieldName) && (this.options.fieldName in this.item)) {
      this.caption = this.value;
      //} else {
        //this.caption = '';
      //}
    }
  }
}
